module.exports = __webpack_public_path__ + "75e6f8e4a396d646e70f8ce8757ba541.svg";